import { render, staticRenderFns } from "./PassengeraddRight.vue?vue&type=template&id=d1789ab8&scoped=true"
import script from "./PassengeraddRight.vue?vue&type=script&lang=js"
export * from "./PassengeraddRight.vue?vue&type=script&lang=js"
import style0 from "./PassengeraddRight.vue?vue&type=style&index=0&id=d1789ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1789ab8",
  null
  
)

export default component.exports